import { WashingMachine, ShowerHead, PawPrint, Droplets, Flame, Wifi } from "lucide-react";
import { amenitiesAtAGlance, type PageAmenityIcon } from "@/data/resort";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

const iconMap: Record<PageAmenityIcon, typeof Wifi> = {
  laundry: WashingMachine,
  showers: ShowerHead,
  dogpark: PawPrint,
  dogwash: Droplets,
  picnic: Flame,
  wifi: Wifi,
};

export function AmenitiesAtAGlance() {
  return (
    <section
      id="at-a-glance"
      aria-labelledby="glance-heading"
      className="bg-secondary/45 py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>At a Glance</Eyebrow>
        </Reveal>
        <h2 id="glance-heading" className="display-lg mt-6 max-w-[16ch]">
          <MaskReveal>Everything Available</MaskReveal>
          <MaskReveal delay={0.08}>During Your Stay</MaskReveal>
        </h2>

        <ul className="mt-10 grid gap-px overflow-hidden border border-border bg-border sm:grid-cols-2 lg:grid-cols-3">
          {amenitiesAtAGlance.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <li key={item.id} className="bg-background">
                <Reveal delay={i * 0.05} className="group h-full">
                  <div className="flex h-full flex-col p-8 transition-colors duration-500 hover:bg-secondary/60 md:p-10">
                    <span className="flex size-14 items-center justify-center rounded-full border border-border bg-secondary/40 text-primary transition-all duration-500 group-hover:-translate-y-1 group-hover:border-primary/40 group-hover:bg-primary/10">
                      <Icon className="size-6" strokeWidth={1.4} />
                    </span>
                    <h3 className="mt-10 font-display text-2xl tracking-tight">{item.title}</h3>
                    <p className="mt-3 max-w-sm text-sm leading-relaxed text-muted-foreground">
                      {item.copy}
                    </p>
                  </div>
                </Reveal>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
